/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrandVisualStudio = createSolidComponent(
  "brand-visual-studio",
  "IconBrandVisualStudio",
  [["path", { d: "M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z" }]]
);

export { IconBrandVisualStudio as default };
//# sourceMappingURL=IconBrandVisualStudio.js.map
